import React, { ReactNode, useEffect, useRef } from 'react'
import { setShowSideModal } from '../../store/selectedAPIs/selectedAPIs.slice'
import { useAppDispatch } from '../../store/storeRequests'

const SideModalWrapper: React.FunctionComponent<{ children: ReactNode }> = ({ children }) => {

    const modalStatic = useRef<HTMLDivElement | null>(null)
    const dispatch = useAppDispatch()
    
    useEffect(() => {
        if (modalStatic !== null) {
            modalStatic.current?.addEventListener('click', () => {
                dispatch(setShowSideModal(false))
            })
        }
    }, [])

  return (
    <div className='admin-right-modal'>
        <div className="modal-static-area" ref={modalStatic}></div>
        <div className="admin-right-content bg-white position-relative">
            { children }
        </div>
    </div>
  )
}

export default SideModalWrapper
